
import { memo } from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';
import type { EdgeProps as ReactFlowEdgeProps } from '@xyflow/react';
import { cn } from '@/lib/utils';

export interface CustomEdgeData {
    label?: string;
    condition?: unknown;
    isDefault?: boolean;
}

type EdgePropsWithData = ReactFlowEdgeProps & {
    data?: CustomEdgeData;
};

export const CustomEdge = memo(function CustomEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    data,
    markerEnd,
    style,
    selected,
}: EdgePropsWithData) {
    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    return (
        <>
            <BaseEdge
                id={id}
                path={edgePath}
                markerEnd={markerEnd}
                style={{
                    ...(style as React.CSSProperties),
                    strokeWidth: selected ? 2 : 1.5,
                    stroke: selected ? '#3b82f6' : '#94a3b8',
                }}
            />
            {data?.label && (
                <EdgeLabelRenderer>
                    <div
                        style={{
                            position: 'absolute',
                            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                            pointerEvents: 'all',
                        }}
                        className={cn(
                            'rounded px-2 py-0.5 text-[10px] font-medium',
                            'border border-slate-200 bg-white shadow-sm',
                            data.isDefault ? 'text-slate-500' : 'text-slate-700'
                        )}
                    >
                        {data.label}
                    </div>
                </EdgeLabelRenderer>
            )}
        </>
    );
});

